import {EApiError} from "./EApiError";

export class EAuthorizationError extends EApiError {
    constructor(message: string) {
        super(message);
        this.name = `${super.name}|'AuthorizationError`;
    }
}